export const translations = {
}



// WEBPACK FOOTER //
// ./src/translations.js